import { lazy, Suspense } from "react";

import { useT } from "../i18n";

// xterm.js is the largest dependency and only the terminal needs it; loading the
// page lazily keeps it out of the shell's chunk.
const WorkspaceTerminalPage = lazy(() => import("./WorkspaceTerminal"));

export default function WorkspaceTerminalLazy() {
  const t = useT().workloads.workflow.terminal;
  return (
    <Suspense fallback={<div className="page note">{t.loading}</div>}>
      <WorkspaceTerminalPage />
    </Suspense>
  );
}
